<script setup lang="ts">
import ToastHost from './components/ToastHost.vue';
</script>

<template>
  <RouterView />
  <ToastHost />
</template>
